var map = {
	"./agroAnima.png": 103,
	"./agroVeg.png": 7892,
	"./commercio.png": 1331,
	"./metalMec.png": 6460,
	"./metalSid.png": 5730,
	"./mobileArr.png": 4538,
	"./modaAbb.png": 7952,
	"./turismo.png": 1648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4378;